module.exports = __webpack_public_path__ + "assets/img_instacart.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_instacart.jpg
 ** module id = 11
 ** module chunks = 1
 **/